<template lang="html">
  <div class="_documents __wrapper_ _scrollbar_custom_">
    <div class="_documents__container" v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
      />
    </div>
    <div class="row h-100"
      v-else-if="docs">
      <div class="_documents__container">
        <div class="row align-items-center">
          <div class="col-md-4"><b>Document Type</b></div>
          <div class="col-md-4 text-center"><b>Remarks</b></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">NPWP</div>
          <div class="col-md text-center"
            v-if="docs.npwp">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.npwp">
            <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'npwp', fileName: `npwp${docs.npwp}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">NIB</div>
          <div class="col-md text-center"
            v-if="docs.nib">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.nib">
            <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'nib', fileName: `nib${docs.nib}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">SIUP</div>
          <div class="col-md text-center"
            v-if="docs.siup">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.siup">
            <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'siup', fileName: `siup${docs.siup}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">KTP</div>
          <div class="col-md text-center"
            v-if="docs.ktp">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.ktp">
             <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'ktp', fileName: `ktp${docs.ktp}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">Passport</div>
          <div class="col-md text-center"
            v-if="docs.passport">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.passport">
             <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'paassport', fileName: `paassport${docs.paassport}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">License</div>
          <div class="col-md text-center"
            v-if="docs.license">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.license">
             <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'license', fileName: `license${docs.license}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="row align-items-center">
          <div class="col-md">Other</div>
          <div class="col-md text-center"
            v-if="docs.others">Uploaded</div>
          <div class="col-md text-center"
            v-else>Not Uploaded</div>
          <div class="col-md d-flex justify-content-end" v-if="docs.others">
            <button
              class="btn__download"
              type="button"
              @click.prevent="downloadDocs({type: 'others', fileName: `others${docs.others}`})">
              <img src = "@/assets/image/icon/download.svg">
            </button>
          </div>
          <div class="col-md d-flex justify-content-end" v-else></div>
        </div>
        <div class="">
          <button @click.prevent="uploadFile()"  type="button" class="text-center _global__button--corporite">+ Upload Document</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'Documents',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      docs: 'settingDocs/docs',
      error: 'settingDocs/error',
      isLoading: 'settingDocs/isLoading'
    })
  },
  mounted () {
    this.fetchDocs()
  },
  methods: {
    uploadFile: function () {
      this.$eventHub.$emit('dialog-setting-upload')
    },
    fetchDocs () {
      this.$store.dispatch('settingDocs/FETCH_DOCS')
    },
    downloadDocs ({type, fileName}) {
      this.$store.dispatch('settingDocs/DOWNLOAD_DOCS', {type, fileName})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Documents.vue